import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { CaretRightIcon, XIcon } from "@phosphor-icons/react";

import Icon from "components/Icon/Icon";
import Button from "components/Buttons";
import StatusPillButtons from "components/Buttons/StatusPillButtons";

import { CreatorSubscriptionModalStyles } from "./styled";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCreatorSubscriptionSlice } from "pages/CreatorUsers/CreatorSubscriptionDetails/slice";
import { getCreatorSubscriptions } from "pages/CreatorUsers/CreatorSubscriptionDetails/slice/selector";
import { format } from "date-fns";
import LoadingSpinner from "components/PageLoader/Spinner";

const CreatorSubscriptionModal = ({ show, onHide, creator, searchParams }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { actions } = useCreatorSubscriptionSlice();

  const { loading, error, subscriptions } = useSelector(
    getCreatorSubscriptions
  );

  useEffect(() => {
    if (show && creator?.id) {
      dispatch(
        actions.fetchCreatorSubscriptionsRequest({
          creator_user_id: creator?.id
        })
      );
    }
  }, [show, creator?.id]);

  const handleViewUsage = (subscription) => {
    onHide();

    const url = `/creator-users/${creator.id}/subscription/${subscription.id}?${searchParams.toString()}`;

    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <CreatorSubscriptionModalStyles
      show={show}
      onHide={onHide}
      className="sidebar-modal"
      backdrop
      keyboard
    >
      <Modal.Header>
        <Modal.Title>
          Plan History – {creator?.first_name} {creator?.last_name}{" "}
        </Modal.Title>

        <div className="close-icon-wrapper" onClick={onHide}>
          <Icon component={XIcon} size={24} />
        </div>
      </Modal.Header>

      <Modal.Body className={`${loading ? "loading" : ""}`}>
        <div className="plan-details-wrapper">
          {loading ? (
            <>
              <LoadingSpinner
                size={12}
                text="Loading..."
                fontSize={12}
                color="#A5A5A5"
              />
            </>
          ) : (
            subscriptions?.map((subscription, index) => (
              <div className="plan-wrapper" key={subscription?.id}>
                <div className="plan-title">
                  <div className="plan-header">
                    <h4>{subscription.plan?.name || "plan"}</h4>

                    <StatusPillButtons status={subscription.status} />
                  </div>

                  <span className="duration">
                    {format(new Date(subscription.start_date), "dd MMM yyyy")} -{" "}
                    {format(new Date(subscription.end_date), "dd MMM yyyy")}
                  </span>
                </div>

                <Button
                  rightIcon={<Icon component={CaretRightIcon} />}
                  size="S"
                  onClick={() => handleViewUsage(subscription)}
                  variant={index === 0 ? "primary" : "secondary"}
                >
                  View Usage
                </Button>
              </div>
            ))
          )}
        </div>
      </Modal.Body>
    </CreatorSubscriptionModalStyles>
  );
};

export default CreatorSubscriptionModal;
